export default {"src":"/_next/static/media/BGB.4059ebcd.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};